import { gql } from '@/shared/graphql/generated/explorer';

export const getOperatorsRewardsQuery = gql(/* GraphQL */ `
  query GetOperatorsRewards($operators: [String!]!) {
    allAccounts(filter: { idSs58: { in: $operators } }) {
      nodes {
        idSs58
        operator: operatorByAccountId {
          operatorEpoch: operatorEpochesByOperatorId {
            aggregates {
              sum {
                amount: operatorRewardAmount
                valueUsd: operatorRewardValueUsd
              }
            }
          }
        }
      }
    }
  }
`);

export const getOperatorTotalsQuery = gql(/* GraphQL */ `
  query GetOperatorTotals($idSs58: String!) {
    operator: allOperatorEpoches(
      filter: { operatorByOperatorId: { accountByAccountId: { idSs58: { equalTo: $idSs58 } } } }
    ) {
      aggregates {
        sum {
          reward: operatorRewardAmount
          rewardValueUsd: operatorRewardValueUsd
          loss: operatorLossAmount
          lossValueUsd: operatorLossValueUsd
        }
      }
    }
    validators: allAuthorityMemberships(
      filter: {
        operatorEpochValidatorByAuthorityMembershipId: {
          operatorEpochByOperatorEpochId: {
            operatorByOperatorId: { accountByAccountId: { idSs58: { equalTo: $idSs58 } } }
          }
        }
      }
    ) {
      aggregates {
        sum {
          reward
          rewardValueUsd
          loss
          lossValueUsd
        }
      }
    }
    delegators: allOperatorEpochDelegations(
      filter: {
        operatorEpochByOperatorEpochId: {
          operatorByOperatorId: { accountByAccountId: { idSs58: { equalTo: $idSs58 } } }
        }
      }
    ) {
      aggregates {
        sum {
          reward: rewards
          rewardValueUsd: rewardsValueUsd
          loss: losses
          lossValueUsd: lossesValueUsd
        }
      }
    }
  }
`);

export const getOperatorEpochValidatorsQuery = gql(/* GraphQL */ `
  query GetOperatorEpochValidators($idSs58: String!, $epochId: Int!) {
    operatorEpochValidators: allOperatorEpochValidators(
      filter: {
        operatorEpochByOperatorEpochId: {
          epochId: { equalTo: $epochId }
          operatorByOperatorId: { accountByAccountId: { idSs58: { equalTo: $idSs58 } } }
        }
      }
    ) {
      nodes {
        validator: validatorByValidatorId {
          account: accountByAccountId {
            idSs58
          }
        }
      }
    }
  }
`);

export const getOperatorEpochsHistoryQuery = gql(/* GraphQL */ `
  query GetOperatorEpochsHistory($idSs58: String!) {
    operatorEpochs: allOperatorEpoches(
      orderBy: EPOCH_ID_DESC
      filter: { operatorByOperatorId: { accountByAccountId: { idSs58: { equalTo: $idSs58 } } } }
    ) {
      nodes {
        epochId
        operatorRewardAmount
        operatorRewardValueUsd
        operatorLossAmount
        operatorLossValueUsd
        stakedAmount
        stakedValueUsd
        epoch: epochByEpochId {
          bond
          startBlockId
          endBlockId
        }
        validators: operatorEpochValidatorsByOperatorEpochId {
          totalCount
          nodes {
            membership: authorityMembershipByAuthorityMembershipId {
              reward
              rewardValueUsd
              loss
              lossValueUsd
            }
          }
        }
        delegations: operatorEpochDelegationsByOperatorEpochId {
          aggregates {
            sum {
              rewards
              rewardsValueUsd
              losses
              lossesValueUsd
            }
          }
        }
      }
    }
  }
`);

export const getOperatorDelegatorDetailsQuery = gql(/* GraphQL */ `
  query GetOperatorDelegatorDetails($operatorIdSs58: String!, $delegatorIds: [String!]!) {
    accounts: allAccounts(filter: { idSs58: { in: $delegatorIds } }) {
      nodes {
        idSs58
        delegations: operatorEpochDelegationsByDelegatorAccountId(
          filter: {
            operatorEpochByOperatorEpochId: {
              operatorByOperatorId: { accountByAccountId: { idSs58: { equalTo: $operatorIdSs58 } } }
            }
          }
        ) {
          aggregates {
            sum {
              rewards
              rewardsValueUsd
            }
          }
        }
        delegatedSince: delegationActivitiesByDelegatorAccountId(
          filter: {
            type: { equalTo: DELEGATE }
            operatorByOperatorId: { accountByAccountId: { idSs58: { equalTo: $operatorIdSs58 } } }
          }
          orderBy: EVENT_ID_DESC
          first: 1
        ) {
          nodes {
            timestamp
          }
        }
      }
    }
  }
`);

export const getOperatorListedDelegatorAccountsQuery = gql(/* GraphQL */ `
  query GetOperatorListedAccounts(
    $operatorIdSs58: String!
    $accountIds: [String!]!
    $type: OperatorActionType!
    $withRewards: Boolean!
  ) {
    accounts: allAccounts(filter: { idSs58: { in: $accountIds } }) {
      nodes {
        idSs58
        listedSince: operatorActionsByAccountId(
          filter: {
            type: { equalTo: $type }
            operatorByOperatorId: { accountByAccountId: { idSs58: { equalTo: $operatorIdSs58 } } }
          }
          orderBy: EVENT_ID_DESC
          first: 1
        ) {
          nodes {
            timestamp
          }
        }
        delegations: operatorEpochDelegationsByDelegatorAccountId(
          filter: {
            operatorEpochByOperatorEpochId: {
              operatorByOperatorId: { accountByAccountId: { idSs58: { equalTo: $operatorIdSs58 } } }
            }
          }
        ) @include(if: $withRewards) {
          aggregates {
            sum {
              rewards
              rewardsValueUsd
            }
          }
        }
      }
    }
  }
`);
